import { render } from "./ProposalSend.vue?vue&type=template&id=837f4480&scoped=true&ts=true"
import script from "./ProposalSend.vue?vue&type=script&lang=ts"
export * from "./ProposalSend.vue?vue&type=script&lang=ts"

import "./ProposalSend.vue?vue&type=style&index=0&id=837f4480&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837f4480"]])

export default __exports__